import { Currencies } from '../../../../types';

import {
  FETCH_CACHE_LAST_DEFAULT_CURRENCY_RATE_QUERY,
  FetchCacheLastDefaultCurrencyRateQueryResponse
} from '../../queries/fetchCacheLastDefaultCurrencyRate.query';

import { useCacheLastDefaultCurrencyRate } from '../useCacheLastDefaultCurrencyRate';

import { CurrencyRateCache } from '../../CurrencyRateCache';

import { getCurrencyPrefix } from '../../utils/getCurrencyPrefix';

interface FormattedCurrencyRatesOptions {
  currency?: Currencies;
}

function useFormattedCurrencyRates(
  { currency } = {} as FormattedCurrencyRatesOptions
) {
  const {
    lastDefaultCurrencyRate,
    lastDefaultCurrencyRateLoading,
    lastDefaultCurrencyRateError
  } = useCacheLastDefaultCurrencyRate<FetchCacheLastDefaultCurrencyRateQueryResponse>(
    {
      cacheKey: CurrencyRateCache.lastDefaultCacheKey(),
      query: FETCH_CACHE_LAST_DEFAULT_CURRENCY_RATE_QUERY
    }
  );

  const item = lastDefaultCurrencyRate;

  const currencyExchangeRate = item?.data?.[currency] || 1;
  const currencyPrefix = getCurrencyPrefix(currency);

  return {
    currencyRatesError: lastDefaultCurrencyRateError,
    currencyRatesLoading: lastDefaultCurrencyRateLoading,
    currencyRatesId: item?.id,
    currencyRatesData: item?.data,
    currencyExchangeRate,
    currencyPrefix
  };
}

export default useFormattedCurrencyRates;
